import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Row,
} from "reactstrap";

const EditaPropietarioOrden = (props) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(
      "https://inspecciongnvback.azurewebsites.net/api/v1/ObtenerPropietariosPorVehiculo/" +
        props.idOrden,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.length > 0) {
          setData(data[0]);
        } else {
          setError(new Error("No data found"));
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setError(error);
        setLoading(false);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const id = parseInt(e.target.dataset.id);

    setData((prevData) => ({
      ...prevData,
      propietario: prevData.propietario.map((propietario) =>
        propietario.id === id ? { ...propietario, [name]: value } : propietario,
      ),
    }));
  };

  const BtnActualizar = async (e) => {
    e.preventDefault();
    try {
      const promises = data.propietario.map((propietario) =>
        axios({
          method: "put",
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
          url: `https://inspecciongnvback.azurewebsites.net/api/v1/ActualizaPropietario/${propietario.id}`,
          data: propietario,
        }),
      );
      const responses = await Promise.all(promises);
      responses.forEach((response) => {
        console.log(response.data);
      });
      alert("Propietarios actualizados con éxito!");
      window.location.reload("/");
    } catch (error) {
      console.error("Error updating owners:", error);
      alert("Error al actualizar los propietarios: " + error);
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <form onSubmit={BtnActualizar}>
      <Container className="mt--1" fluid>
        <Card className="shadow">
          <CardBody>
            <Row>
              <Col>
                <h3>Propietario</h3>
                {data && data.propietario && data.propietario.length > 0 ? (
                  data.propietario.map((propietario, index) => (
                    <Row key={index}>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor={`input-nombre-${index}`}
                          >
                            Nombre
                          </label>
                          <Input
                            className="form-control-alternative"
                            type="text"
                            name="nombre"
                            id={`input-nombre-${index}`}
                            value={propietario.nombre}
                            onChange={handleChange}
                            data-id={propietario.id}
                          />
                        </FormGroup>
                      </Col>

                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor={`input-documento-${index}`}
                          >
                            Documento
                          </label>
                          <Input
                            className="form-control-alternative"
                            type="text"
                            name="documento"
                            id={`input-documento-${index}`}
                            value={propietario.documento}
                            onChange={handleChange}
                            data-id={propietario.id}
                          />
                        </FormGroup>
                      </Col>

                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor={`input-telefono-${index}`}
                          >
                            Teléfono
                          </label>
                          <Input
                            className="form-control-alternative"
                            type="text"
                            name="telefono"
                            id={`input-telefono-${index}`}
                            value={propietario.telefono}
                            onChange={handleChange}
                            data-id={propietario.id}
                          />
                        </FormGroup>
                      </Col>

                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor={`input-correo-${index}`}
                          >
                            Correo
                          </label>
                          <Input
                            className="form-control-alternative"
                            type="text"
                            name="correo"
                            id={`input-correo-${index}`}
                            value={propietario.correo}
                            onChange={handleChange}
                            data-id={propietario.id}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  ))
                ) : (
                  <div>No hay propietario disponible</div>
                )}
              </Col>
            </Row>
            <Button color="primary" type="submit">
              Actualizar Propietario
            </Button>
          </CardBody>
        </Card>
      </Container>
    </form>
  );
};

export default EditaPropietarioOrden;
